<ng-container *ngIf="isScreenLarge; else mobileLayout">
    <div class="main-tab-title-box">
      <mat-card-title class="main-title">Summary</mat-card-title>
      <div>
        <analysis-options></analysis-options>
      </div>
    </div>
    <div *ngIf="loaderActive" class="div_loader_pag">
      <div  id="div_loader_pag">
        <div  class="loader_pag"></div>
      </div>
      <div class="main-box-title-12">Analysis will begin after you finish typing</div>
    </div>
    <div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
      <div  id="div_loader_pag">
        <div  class="loader_pag"></div>
      </div>
      <div class="main-box-title-12">Analysing and Saving</div>
    </div>
    <div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
      <div  id="div_loader_pag">
        <div  class="loader_pag"></div>
      </div>
      <div class="main-box-title-12">Analysing...</div>
    </div>
    <mat-card-content>
      <div *ngIf="summary.cefr !== null && summary.cefr !== undefined">
        <span class="main-box-title-14">Click on one of the measures in the boxes below for more details.</span>
      </div>
      <div id="summary-box" style="grid-column: span 2; margin-top: 5px; cursor: pointer;" (click)="onSelectMenuItem('scorecardfree')">
        <div class="main-box-title-16"><span style="opacity: 0.5;">CEFR Level ({{ currentAnalysisMode }}) </span>  <div>
          <img (mouseenter)="openTooltipModal($event)" 
          (mouseleave)="closeTooltipModal()" (click)="$event.stopPropagation()" style=" padding-top: 2px; width: 18px; height: 18px; margin-left: 10px;" src="./assets/images/black_icons/blocked-icon.svg">
          </div>
        </div>
        <div class="main-box-value-48" style="margin-top: 15px; margin-bottom: 15px;">{{summary.cefr ? summary.cefr:"--"}}</div>
        <div *ngIf="summary.cefr !== null && summary.cefr !== undefined">
          <div class="scorecard-title" style="text-align: center;">Key to CEFR Levels</div>
            <div class="scorecard-box-sub scroll_scores" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('A1'), 'not-matching': !isMatchingLevel('A1')}">
                        A1
                    </div>
                    <div class="little-title">Beginner</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('A2'), 'not-matching': !isMatchingLevel('A2')}" style="margin-left: 6px;">
                        A2
                    </div>
                    <div class="little-title">Elementary</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('B1'), 'not-matching': !isMatchingLevel('B1')}"style="margin-left: 8px;">
                        B1
                    </div>
                    <div class="little-title">Intermediate</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box"[ngClass]="{'matching': isMatchingLevel('B2'), 'not-matching': !isMatchingLevel('B2')}" style="margin-left: 8px; margin-top: 18px;">
                        B2
                    </div>
                    <div class="little-title">Upper <br> Intermediate</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('C1'), 'not-matching': !isMatchingLevel('C1')}" style="margin-left: 2px;">
                        C1
                    </div>
                    <div class="little-title">Advanced</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('C2'), 'not-matching': !isMatchingLevel('C2')}" style="margin-left: 2px;">
                        C2
                    </div>
                    <div class="little-title">Proficiency</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('D1'), 'not-matching': !isMatchingLevel('D1')}" style="margin-left: 2px;">
                        D1
                    </div>
                    <div class="little-title">Academic</div>
                </div>
                <div class="vertical-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('D2'), 'not-matching': !isMatchingLevel('D2')}" style="margin-left: 3px; margin-top: 17px;">
                        D2
                    </div>
                    <div class="little-title">Upper <br> Academic</div>
                </div>
            </div>
        </div>
      </div>
      <div class="summary-grid scroll-grid">
        <div class="vertical-box-summary" style="cursor: pointer; min-width: 260px;" (click)="onSelectMenuItem('readabilityfree')">
          <div class="horizontal-box" style="border: none; padding-bottom: 8px;">
            <div class="main-box-title-16" style="text-align: left;">Flesch Kincaid <br>Grade</div>
            <div *ngIf="!loaderActiveSummary2" class="main-box-value-32" id="div_value_flesch_kincaid">{{getFleschKincaidDisplay()}}</div>
             <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
          </div>
          <div *ngIf="isThereProject && summary2.flesch_kincaid !== undefined && !loaderActiveSummary2"  style="position: relative; bottom: 0;">
            <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
              <mat-progress-bar mode="determinate" value="{{summary2.flesch_kincaid}}" color="accent"></mat-progress-bar>
            </div>
            <div [ngClass]="getBoxLineColorKincaid(summary2.flesch_kincaid)">
              <div class="main-box-title-12">{{getTextLineFlesch(summary2.flesch_kincaid)}}</div>
            </div>
          </div>
        </div>
        
        <div class="vertical-box-summary" style="  cursor: pointer; min-width: 260px;" (click)="onSelectMenuItem('lexicalfree')">
          <div class="horizontal-box" style="border: none; padding-bottom: 8px;">
            <div class="main-box-title-16" style="text-align: left;">Lexical Diversity <br>(VOCD)</div>
            <div *ngIf="!loaderActiveSummary2" class="main-box-value-32" id="div_value_lexical">{{getLexicalDisplay()}}</div>
            <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
          </div>
          <div *ngIf="isThereProject && summary2.lexical !== undefined && !loaderActiveSummary2">
            <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
              <mat-progress-bar mode="determinate" value="{{summary2.lexical}}" color="accent"></mat-progress-bar>
            </div>
            <div [ngClass]="getBoxLineColorVOCD(summary2.lexical)">
              <div class="main-box-title-12">{{ getTextLineLexical(summary2.lexical)}}</div>
            </div>
          </div>
        </div>
    
        <div class="vertical-box-summary" style="  cursor: pointer; min-width: 260px;" (click)="onSelectMenuItem('awlfree')">
          <div class="horizontal-box" style="border: none; padding-bottom: 8px;">
            <div class="main-box-title-16" style="text-align: left;">Percentage of Academic<br>Words (tokens)</div>
            <div *ngIf="!loaderActiveSummary3" class="main-box-value-32" id="div_value_academic">{{getAcademicDisplay()}}</div>
            <div *ngIf="loaderActiveSummary3" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
          </div>
          <div *ngIf="isThereProject && summary3.academic !== undefined && !loaderActiveSummary3">
            <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
              <mat-progress-bar mode="determinate" [value]="mapToPercentage(summary3.academic/3.10)" color="accent"></mat-progress-bar>
            </div>
            <div [ngClass]="getBoxLineColorAcademic(summary3.academic)">
              <div class="main-box-title-12">{{getTextLineAcademic(summary3.academic)}}</div>
            </div>
          </div>
        </div>
    
        <div class="vertical-box-summary" style="  cursor: pointer; min-width: 260px;" (click)="onSelectMenuItem('evpfree')">
          <div class="horizontal-box" style="border: none; padding-bottom: 8px;">
            <div class="main-box-title-16" style="text-align: left;">Percentage of Words (Tokens)<br>at B1 CEFR Level</div>
            <div *ngIf="!loaderActiveSummary3" class="main-box-value-32" id="div_value_words_level">{{getWordsLevelDisplay()}}</div>
            <div *ngIf="loaderActiveSummary3" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
          </div>
          <div *ngIf="isThereProject && summary3.words_level !== undefined && !loaderActiveSummary3">
            <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
              <mat-progress-bar mode="determinate" [value]="((100-(summary3.words_level-6))/300)*100" color="accent"></mat-progress-bar>
            </div>
            <div [ngClass]="getBoxLineColorWordsLevel(summary3.words_level)">
              <div class="main-box-title-12">{{getTextLineWordsLevel(summary3.words_level)}}</div>
            </div>
          </div>
        </div>
    
      </div>
      <div *ngIf="lexical_short_words" class="message">
        <div class="line"></div>
        <p>Lexical score are not accurate on short documents.</p>
      </div>
      <div *ngIf="short_words" class="message">
        <div class="line"></div>
        <p>Scores are not accurate on short documents.</p>
      </div>
      <div class="summary-grid"></div><!--ESPACIO-->
      <div class="horizontal-box">
        <div class="main-box-title-14">
          <img *ngIf="summary.sentence_count !== null && summary.sentence_count !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon_Sentence($event, summary.sentences_data)">
          Sentence count
        </div>
        <div *ngIf="!loaderActiveSummary1" class="main-box-value-16-bold" >{{summary.sentence_count ? summary.sentence_count:"--"}}</div>
         <div *ngIf="loaderActiveSummary1" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
      </div>
      <div class="horizontal-box">
        <div class="main-box-title-14" style="text-align: left;">
          <img *ngIf="summary2.word_count !== null && summary2.word_count !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon_Words($event, summary2.word_data)">
          Token count (similar to word count) <div class="tooltip-container">
            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
            <span class="tooltip-text">
              Tokens are similar to words, but include punctuation and other elements.
            </span>
          </div><span *ngIf="excludeDigits">, (excluding numbers)</span>
        </div>
        <div *ngIf="!loaderActiveSummary2" class="main-box-value-16-bold" >{{summary2.word_count ? summary2.word_count:"--"}}</div>
         <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
      </div>
    
      <!-- <div *ngIf="summary.issues === null || summary.issues === undefined">
        <div class="summary-grid space"></div>
        <div class="main-box-title-14 horizontal-items">Number of possible modifications to reach your CEFR Level Target: <div class="main-box-value-16-bold" style="margin-left: 6px;">--</div></div>
        <div class="space2"></div>
          <div class="tooltip-content">
            <div class="line"></div>
            <p style="display: flex; font-weight: 400;">Warning: we do not recommend trying to increase the CEFR Level of authentic listening or reading texts for in-classroom use.</p>
          </div>
        <div style="display: flex; width: auto; align-items: center; text-align: center; justify-content: space-between;">
          <span class="main-box-title-14">Achieve your desired CEFR level by modifying the metrics below.</span>
          <button mat-button class="icon-button" style="color: #EEA21A;">
            <span class="button-export"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" style="width: 17px; padding-right: 8px;"></div><span>Export</span></span>
          </button>
        </div>
      </div> -->
    
      <!-- <div *ngIf="summary.issues !== null && summary.issues !== undefined">
        <div class="summary-grid space"></div>
        <div class="main-box-title-14 horizontal-items">Possible Improvements: <div class="main-box-value-16-bold" style="margin-left: 6px;">{{summary.issues ? summary.issues:"--"}}</div></div>
        <div class="space2"></div>
        <span class="main-box-title-14">Click on the ‘<img class="eye-icon eye-text" style="margin-right: 0px;" src="./assets/images/eye-icon.svg">‘ icons below to highlight the relevant sections in your text. Click on a metric to be taken to the relevant section of Text Inspector.</span>
        <br>
        <div class="tooltip-content">
          <div class="line"></div>
          <p style="display: flex; font-weight: 400;">Warning: we do not recommend trying to increase the CEFR Level of authentic listening or reading texts for in-classroom use.</p>
        </div>
        <div >
          <span class="main-box-title-14">Achieve your desired CEFR level by modifying the metrics below.</span>
          <button mat-button class="icon-button" style="color: #EEA21A;">
            <span class="button-export"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" style="width: 17px; padding-right: 8px;"></div><span>Export</span></span>
          </button>
        </div>
      </div>
    
      <div class="horizontal-box" style="margin-top: 10px;">
        <div class="main-box-title-14" >
          <img *ngIf="summary.sentences_30 !== null && summary.sentences_30 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
          Sentences > 30 syllables
        </div>
        <div class="main-box-value-16-bold" >{{summary.sentences_30 ? summary.sentences_30:"--"}}</div>
      </div>
      
      <div class="horizontal-box">
        <div class="main-box-title-14" >
          <img *ngIf="summary.sentences_20 !== null && summary.sentences_20 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
          Sentences > 20 syllables
        </div>
        <div class="main-box-value-16-bold" >{{summary.sentences_20 ? summary.sentences_20:"--"}}</div>
      </div>
    
      <div class="horizontal-box">
        <div class="main-box-title-14" >
          <img *ngIf="summary.words_4 !== null && summary.words_4 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
          Words with more than 4 syllabes
        </div>
        <div class="main-box-value-16-bold" >{{summary.words_4 ? summary.words_4:"--"}}</div>
      </div>
    
      <div class="horizontal-box">
        <div class="main-box-title-14" >
          <img *ngIf="summary.words_3 !== null && summary.words_3 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
          Words with more than 3 syllabes
        </div>
        <div class="main-box-value-16-bold" >{{summary.words_3 ? summary.words_3:"--"}}</div>
      </div>
    
      <div class="horizontal-box">
        <div class="main-box-title-14" >
          <img *ngIf="summary.words_2 !== null && summary.words_2 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
          Words with more than 2 syllabes
        </div>
        <div class="main-box-value-16-bold" >{{summary.words_2 ? summary.words_2:"--"}}</div>
      </div>
    
      <div class="horizontal-box">
        <div class="main-box-title-14" >
          <img *ngIf="summary.words_12 !== null && summary.words_12 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
          Words with more than 12 letters
        </div>
        <div class="main-box-value-16-bold" >{{summary.words_12 ? summary.words_12:"--"}}%</div>
      </div>
    
      <div class="horizontal-box">
        <div class="main-box-title-14">
          <img *ngIf="summary.words_10 !== null && summary.words_10 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
          Words with more than 10 letters
        </div>
        <div class="main-box-value-16-bold" >{{summary.words_10 ? summary.words_10:"--"}}</div>
      </div> -->
    
    </mat-card-content>
    
    </ng-container>
    
    <!-------------------->
    <!-------------------->
    <!--------MOBIL------->
    <!-------------------->
    <!-------------------->
    
    <ng-template #mobileLayout>
      <div class="main-tab-title-box">
        <mat-card-title class="main-title">Summary</mat-card-title>
        <div>
          <analysis-options></analysis-options>
        </div>
      </div>
         <div *ngIf="loaderActive" class="div_loader_pag">
      <div  id="div_loader_pag">
        <div  class="loader_pag"></div>
      </div>
      <div class="main-box-title-12">Analysis will begin after you finish typing</div>
    </div>
    <div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
      <div  id="div_loader_pag">
        <div  class="loader_pag"></div>
      </div>
      <div class="main-box-title-12">Analysing and Saving</div>
    </div>
    <div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
      <div  id="div_loader_pag">
        <div  class="loader_pag"></div>
      </div>
      <div class="main-box-title-12">Analysing...</div>
    </div>
      <mat-card-content>
        <div id="summary-box" style="grid-column: span 2;cursor: pointer;" (click)="onSelectMenuItem('scorecardfree')">
          <div class="main-box-title-16"><span style="opacity: 0.5;">CEFR Level ({{ currentAnalysisMode }})</span>
            <div>
              <img (click)="openTooltipModalMobile($event)" style=" padding-top: 2px; width: 18px; height: 18px; margin-left: 10px;" src="./assets/images/black_icons/blocked-icon.svg">
              </div>
          </div>
          <div class="main-box-value-48" style="margin-top: 15px; margin-bottom: 15px;">{{summary.cefr ? summary.cefr:"--"}}</div>
          <div *ngIf="summary.cefr !== null && summary.cefr !== undefined">
            <div class="scorecard-title" style="text-align: center;">Key to CEFR Levels</div>
              <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                  <div class="vertical-box cefr-box"style="border: none;">
                      <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('A1'), 'not-matching': !isMatchingLevel('A1')}" style="margin-left: 8px;">
                          A1
                      </div>
                      <div class="little-title">Beginner</div>
                  </div>
                  <div class="vertical-box cefr-box"style="border: none;">
                      <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('A2'), 'not-matching': !isMatchingLevel('A2')}" style="margin-left: 8px;">
                          A2
                      </div>
                      <div class="little-title">Elementary</div>
                  </div>
                  <div class="vertical-box cefr-box"style="border: none;">
                      <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('B1'), 'not-matching': !isMatchingLevel('B1')}" style="margin-left: 8px;">
                          B1
                      </div>
                      <div class="little-title">Intermediate</div>
                  </div>
                  <div class="vertical-box cefr-box"style="border: none;">
                      <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('B2'), 'not-matching': !isMatchingLevel('B2')}" style="margin-left: 8px; margin-top: 18px;">
                          B2
                      </div>
                      <div class="little-title">Upper <br> Intermediate</div>
                  </div>
              </div>
    
              <div class="scorecard-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
                <div class="vertical-box cefr-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('C1'), 'not-matching': !isMatchingLevel('C1')}" style="margin-left: 8px;">
                        C1
                    </div>
                    <div class="little-title">Advanced</div>
                </div>
                <div class="vertical-box cefr-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('C2'), 'not-matching': !isMatchingLevel('C2')}" style=" margin-left: 8px;">
                        C2
                    </div>
                    <div class="little-title">Proficiency</div>
                </div>
                <div class="vertical-box cefr-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('D1'), 'not-matching': !isMatchingLevel('D1')}" style="margin-left: 8px;">
                        D1
                    </div>
                    <div class="little-title">Academic</div>
                </div>
                <div class="vertical-box cefr-box"style="border: none;">
                    <div class="scorecard-score-box" [ngClass]="{'matching': isMatchingLevel('D2'), 'not-matching': !isMatchingLevel('D2')}" style="margin-left: 8px; margin-top: 17px;">
                        D2
                    </div>
                    <div class="little-title">Upper <br> Academic</div>
                </div>
            </div>
          </div>
        </div>
        <div class="summary-grid">
          <div class="vertical-box" style=" margin-bottom: 2px; cursor: pointer;" (click)="onSelectMenuItem('readabilityfree')">
            <div class="horizontal-box" style="border: none; padding-bottom: 0px; height: 35px; justify-content: center;">
              <div class="main-box-title-16" style="text-align: center;">Flesch-Kincaid Grade</div>
            </div>
            <div *ngIf="!loaderActiveSummary2" class="main-box-value-32" id="div_value_flesch_kincaid">{{getFleschKincaidDisplay()}}</div>
            <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom:20px">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
            <div *ngIf="isThereProject && summary2.flesch_kincaid !== undefined && !loaderActiveSummary2" style="height: 100%;">
              <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
                <mat-progress-bar mode="determinate" value="{{summary2.flesch_kincaid}}" color="accent"></mat-progress-bar>
              </div>
              <div [ngClass]="getBoxLineColorKincaid(summary2.flesch_kincaid)">
                <div class="main-box-title-12">{{getTextLineFlesch(summary2.flesch_kincaid)}}</div>
              </div>
            </div>
          </div>
          
          <div class="vertical-box" style=" margin-bottom: 2px; cursor: pointer;" (click)="onSelectMenuItem('lexicalfree')">
            <div class="horizontal-box" style="border: none; padding-bottom: 0px;height: 35px;justify-content: center;">
              <div class="main-box-title-16" style="text-align: center;">Lexical Diversity (VOCD)</div>
            </div>
            <div *ngIf="!loaderActiveSummary2" class="main-box-value-32" id="div_value_lexical">{{getLexicalDisplay()}}</div>
            <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom:20px">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
            <div *ngIf="isThereProject && summary2.lexical !== undefined && !loaderActiveSummary2">
              <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
                <mat-progress-bar mode="determinate" value="{{summary2.lexical}}" color="accent"></mat-progress-bar>
              </div>
              <div [ngClass]="getBoxLineColorVOCD(summary2.lexical)">
                <div class="main-box-title-12">{{ getTextLineLexical(summary2.lexical)}}<span style="visibility: hidden;">000Reading Level sdfsf</span></div>
              </div>
            </div>
          </div>
      
          <div class="vertical-box" style=" margin-bottom: 2px; cursor: pointer;" (click)="onSelectMenuItem('awlfree')">
            <div class="horizontal-box" style="border: none; padding-bottom: 0px;height: 60px;justify-content: center;">
              <div class="main-box-title-16" style="text-align: center;">Percentage of Academic Words (Tokens)</div>
              
            </div>
            <div *ngIf="!loaderActiveSummary3" class="main-box-value-32" id="div_value_academic">{{getAcademicDisplay()}}</div>
            <div *ngIf="loaderActiveSummary3" class="div_loader_pag" style="margin-bottom:20px">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
            <div *ngIf="isThereProject && summary3.academic !== undefined && !loaderActiveSummary3">
              <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;justify-content: center;">
                <mat-progress-bar mode="determinate" [value]="mapToPercentage(summary3.academic/3.10)" color="accent"></mat-progress-bar>
              </div>
              <div [ngClass]="getBoxLineColorAcademic(summary3.academic)">
                <div class="main-box-title-12">{{getTextLineAcademic(summary3.academic)}}<span style="visibility: hidden;">sdf</span></div>
              </div>
            </div>
          </div>
      
          <div class="vertical-box" style=" margin-bottom: 2px; cursor: pointer;" (click)="onSelectMenuItem('evpfree')">
            <div class="horizontal-box" style="border: none; padding-bottom: 0px;height: 60px;">
              <div class="main-box-title-16" style="text-align: center;">Percentage of Tokens at B1 CEFR Level</div>
            </div>
            <div *ngIf="!loaderActiveSummary3" class="main-box-value-32" id="div_value_words_level">{{getWordsLevelDisplay()}}
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
            <div *ngIf="isThereProject && summary3.words_level !== undefined && !loaderActiveSummary3">
              <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
                <mat-progress-bar mode="determinate" [value]="((100-(summary3.words_level-6))/300)*100" color="accent"></mat-progress-bar>
              </div>
              <div [ngClass]="getBoxLineColorWordsLevel(summary3.words_level)">
                <div class="main-box-title-12">{{getTextLineWordsLevel(summary3.words_level)}}</div>
              </div>
            </div>
          </div>
      
        </div>
        <div class="summary-grid"></div><!--ESPACIO-->
      <div class="horizontal-box">
        <div class="main-box-title-14">
          <img *ngIf="summary.sentence_count !== null && summary.sentence_count !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon_Sentence($event, summary.sentences_data)">
          Sentence count
        </div>
        <div *ngIf="!loaderActiveSummary1" class="main-box-value-16-bold" >{{summary.sentence_count ? summary.sentence_count:"--"}}</div>
         <div *ngIf="loaderActiveSummary1" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
      </div>
      <div class="horizontal-box">
        <div class="main-box-title-14"  style="text-align: left;">
          <img *ngIf="summary2.word_count !== null && summary2.word_count !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon_Words($event, summary2.word_data)">
          Token count (similar to word count) <div class="tooltip-container">
            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
            <span class="tooltip-text">
              Tokens are similar to words, but include punctuation and other elements.
            </span>
          </div><span *ngIf="excludeDigits">, (excluding numbers)</span>
        </div>
        <div *ngIf="!loaderActiveSummary2" class="main-box-value-16-bold" >{{summary2.word_count ? summary2.word_count:"--"}}</div>
         <div *ngIf="loaderActiveSummary2" class="div_loader_pag" style="margin-bottom: 0px;">
            <div id="div_loader_pag">
              <div class="loader_pag" style="width: 16px; height: 16px;"></div>
            </div>
          </div>
      </div>
        <!-- <div *ngIf="summary.issues === null || summary.issues === undefined">
          <div class="summary-grid space"></div>
          <div class="main-box-title-14 horizontal-items">Number of possible modifications to reach your CEFR Level Target: <div class="main-box-value-16-bold" style="margin-left: 6px;">--</div></div>
          <div class="space2"></div>
          <div class="tooltip-content">
            <div class="line"></div>
            <p style="display: flex; font-weight: 400;">Warning: we do not recommend trying to increase the CEFR Level of authentic listening or reading texts for in-classroom use.</p>
          </div>
          <div style="display: flex; width: auto; align-items: center; text-align: center; justify-content: space-between;">
            <span class="main-box-title-14"  style="text-align: left;">Achieve your desired CEFR level by modifying the metrics below.</span>
            <button mat-button class="icon-button" style="color: #EEA21A;">
              <span class="button-export"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" style="width: 17px; padding-right: 8px;"></div><span>Export</span></span>
            </button>
          </div>
        </div> -->
      
        <!-- <div *ngIf="summary.issues !== null && summary.issues !== undefined">
          <div class="summary-grid space"></div>
          <div class="main-box-title-14 horizontal-items">Possible Improvements: <div class="main-box-value-16-bold" style="margin-left: 6px;">{{summary.issues ? summary.issues:"--"}}</div></div>
          <div class="space2"></div>
          <span class="main-box-title-14">Click on the ‘<img class="eye-icon eye-text" style="margin-right: 0px;" src="./assets/images/eye-icon.svg">‘ icons below to highlight the relevant sections in your text. Click on a metric to be taken to the relevant section of Text Inspector.</span>
          <br>
          <div class="tooltip-content">
            <div class="line"></div>
            <p style="display: flex; font-weight: 400;">Warning: we do not recommend trying to increase the CEFR Level of authentic listening or reading texts for in-classroom use.</p>
          </div>
          <div style="display: flex; width: auto; align-items: center; text-align: center; justify-content: space-between;">
            <span class="main-box-title-14" style="text-align: left;">Achieve your desired CEFR level by modifying the metrics below.</span>
            <button mat-button class="icon-button" style="color: #EEA21A;">
              <span class="button-export"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" style="width: 17px; padding-right: 8px;"></div><span>Export</span></span>
            </button>
          </div>
        </div>
      
        <div class="horizontal-box" style="margin-top: 10px;">
          <div class="main-box-title-14" >
            <img *ngIf="summary.sentences_30 !== null && summary.sentences_30 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
            Sentences > 30 syllables
          </div>
          <div class="main-box-value-16-bold" >{{summary.sentences_30 ? summary.sentences_30:"--"}}</div>
        </div>
        
        <div class="horizontal-box">
          <div class="main-box-title-14" >
            <img *ngIf="summary.sentences_20 !== null && summary.sentences_20 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
            Sentences > 20 syllables
          </div>
          <div class="main-box-value-16-bold" >{{summary.sentences_20 ? summary.sentences_20:"--"}}</div>
        </div>
      
        <div class="horizontal-box">
          <div class="main-box-title-14" >
            <img *ngIf="summary.words_4 !== null && summary.words_4 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
            Words with more than 4 syllabes
          </div>
          <div class="main-box-value-16-bold" >{{summary.words_4 ? summary.words_4:"--"}}</div>
        </div>
      
        <div class="horizontal-box">
          <div class="main-box-title-14" >
            <img *ngIf="summary.words_3 !== null && summary.words_3 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
            Words with more than 3 syllabes
          </div>
          <div class="main-box-value-16-bold" >{{summary.words_3 ? summary.words_3:"--"}}</div>
        </div>
      
        <div class="horizontal-box">
          <div class="main-box-title-14" >
            <img *ngIf="summary.words_2 !== null && summary.words_2 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
            Words with more than 2 syllabes
          </div>
          <div class="main-box-value-16-bold" >{{summary.words_2 ? summary.words_2:"--"}}</div>
        </div>
      
        <div class="horizontal-box">
          <div class="main-box-title-14" >
            <img *ngIf="summary.words_12 !== null && summary.words_12 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
            Words with more than 12 letters
          </div>
          <div class="main-box-value-16-bold" >{{summary.words_12 ? summary.words_12:"--"}}%</div>
        </div>
      
        <div class="horizontal-box">
          <div class="main-box-title-14">
            <img *ngIf="summary.words_10 !== null && summary.words_10 !== undefined" class="eye-icon eye-text" src="./assets/images/eye-icon.svg" (click)="toggleEyeIcon($event)">
            Words with more than 10 letters
          </div>
          <div class="main-box-value-16-bold" >{{summary.words_10 ? summary.words_10:"--"}}</div>
        </div> -->
      
      </mat-card-content>
      
    </ng-template>